import { render } from "./user-company-access.vue?vue&type=template&id=1a3a21dc&ts=true"
import script from "./user-company-access.vue?vue&type=script&lang=ts"
export * from "./user-company-access.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__